<div class="container"
     [class.hover-image]="canChangeImage">
  <img src="{{computeImageSrc()}}"
       [class.canChange]="canChangeImage"
       alt=""
       (load)="onLoad()">
  <div class="middle">
    <i class="material-icons" *ngIf="canChangeImage" (click)="onImageUploadClick()">{{'file_upload'}}</i>
    <i class="material-icons" *ngIf="canDeleteImage" (click)="onImageDeleteClick()">{{'delete_forever'}}</i>
  </div>
</div>
